import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { authGuardSubmodule } from '../../auth/auth.guard';
import { CuadroMandoIntegralComponent } from './cuadro-mando-integral/cuadro-mando-integral.component';
import { ProyectosEstrategicosComponent } from './proyectos-estrategicos/proyectos-estrategicos.component';
import { PlanesComponent } from './planes/planes.component';
import { ObjetivosComponent } from './objetivos/objetivos.component';
import { IndicadoresMetasComponent } from './indicadores-metas/indicadores-metas.component';
import { ActasComponent } from './actas/actas.component';
import { EstrategiasComponent } from './estrategias/estrategias.component';

const routes: Routes = [
  {
    path: 'app/seguimiento',
    component: ContenedorComponent,
    children: [
      {path: 'cuadro-mando', component: CuadroMandoIntegralComponent, canActivate: [authGuardSubmodule]},
      {path: 'proyectos-estrategicos', component: ProyectosEstrategicosComponent, canActivate: [authGuardSubmodule]},
      {path: 'objetivos', component: ObjetivosComponent, canActivate: [authGuardSubmodule]},
      {path: 'planes', component: PlanesComponent, canActivate: [authGuardSubmodule]},
      {path: 'indicadores-metas', component: IndicadoresMetasComponent, canActivate: [authGuardSubmodule]},
      {path: 'actas', component: ActasComponent, canActivate: [authGuardSubmodule]},
      {path: 'estrategias', component: EstrategiasComponent, canActivate: [authGuardSubmodule]},
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SeguimientoRoutingModule { }
